// extracted by mini-css-extract-plugin
export default {"expired":"Expired_expired__dIAgZ","content_wrapper":"Expired_content_wrapper__rZJTW","title":"Expired_title__XGew0","description":"Expired_description__nDrRU"};